export default __webpack_public_path__ + "static/media/users-collapse-active.2d59a11a.svg";